import { LockClosedIcon } from "@heroicons/react/24/outline";
import { CARD_TEXTURE_SURFACE } from "@/lib/styles/surfaces";

interface NdaWorkCardProps {
  accentColor?: string;
}

export default function NdaWorkCard({
  accentColor = "#71D9C5",
}: NdaWorkCardProps) {
  return (
    <div
      className={`relative flex h-full min-h-0 flex-col rounded-xl overflow-hidden ${CARD_TEXTURE_SURFACE}`}
    >
      <div className="relative flex flex-1 flex-col p-6 text-text-light dark:text-text-dark">
        <div className="relative mb-6 shrink-0">
          <div
            className="absolute inset-0 -m-2 rounded-lg opacity-[0.12]"
            style={{ backgroundColor: accentColor }}
          />
          <div className="relative aspect-video rounded-md overflow-hidden bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
            <LockClosedIcon className="w-12 h-12 text-gray-400 dark:text-gray-500" />
          </div>
        </div>

        <div className="flex flex-1 flex-col gap-4">
          <div className="flex shrink-0 items-center gap-3">
            <div className="w-10 h-10 rounded-full overflow-hidden bg-black/5 dark:bg-white/10 flex items-center justify-center">
              <LockClosedIcon className="w-5 h-5 text-gray-400 dark:text-gray-500" />
            </div>
            <div>
              <h3 className="text-xl font-medium text-text-light dark:text-text-dark">
                Under NDA
              </h3>
              <p className="text-sm text-text-muted-light dark:text-text-muted-dark">
                Confidential Project
              </p>
            </div>
          </div>

          <div className="flex flex-1 flex-col gap-3">
            <p className="text-sm text-text-muted-light dark:text-text-muted-dark">
              Confidential medical device project
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
